module.exports = __webpack_public_path__ + "img/module-academy.54ad2338.svg";